/**
 * Structured logging for the browser / Next client.
 *
 * - Core: `frontendLogger`, `createLifecycleLogger` → `loggerCore.ts`
 * - Domain helpers (import from these modules for new code):
 *   - `schedulingLog.ts` — scheduler steps + `schedulerLogger` compat object
 *   - `authLog.ts` — auth events + `authLogger` compat object
 *   - `fetchLog.ts` — HTTP client instrumentation + `fetchLogger` compat object
 *   - `paymentLog.ts` — payment lifecycle + `paymentLogger` compat object
 */

export { frontendLogger, createLifecycleLogger } from './loggerCore';

export {
  captureSchedulerFailure,
  schedulerLogger,
  schedulerResumeDraftSkipped,
  schedulerStepCompleted,
  schedulerStepFailed,
  schedulerStepRetried,
  schedulerStepSkipped,
  schedulerStepStarted,
  schedulerStepWarning,
} from './schedulingLog';

export {
  authLogger,
  authLoginAttempt,
  authLoginFailed,
  authLoginSuccess,
  authMagicLinkRequestStarted,
  authMagicLinkSendFailed,
  authMagicLinkSent,
  authSessionExpired,
  authSessionLogContext,
  authSignOut,
  authSocialSignInStarted,
} from './authLog';

export {
  fetchLogger,
  logFetchFailed,
  logFetchRequest,
  logFetchSuccess,
} from './fetchLog';

export { paymentLifecycleLog, paymentLogger } from './paymentLog';
